import { useContext } from 'react'

import { WidgetsContext } from '@/components/dashboard/widgets/context'

export const useWidgets = () => {
  const context = useContext(WidgetsContext)
  if (!context) {
    throw new Error('useWidgets must be used within a WidgetsContext.Provider')
  }
  return context
}
